import React from 'react'
import ButtonWithLoader from '../../components/ButtonWithLoader'
import InputControl from '../../components/InputControl'
import { Controller, useForm } from 'react-hook-form'
import { Link,useNavigate,useParams } from 'react-router-dom'
import { industrymanagement } from '../../Routes/routingConsts'
import { Dropdown, Form, InputGroup ,Button} from 'react-bootstrap'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import requestApi from '../../utils/request'
import { useMutation, useQuery } from 'react-query'
import Swal from 'sweetalert2'
const AddNewIndustry = () => {
    const industryValidationInput = yup.object({
        industryName:yup.string().required('Please enter industry name')
    })
    const {
        handleSubmit,
        reset,
        register,
        control,
        formState: { errors }
    } = useForm({resolver:yupResolver(industryValidationInput)})
    const navigate = useNavigate()
    const {industryId} = useParams()
   


// add - edit industry ///
async function addIndustry(payload){
    if(industryId){
        return await requestApi.post(`industry/add-edit`,{industryId,...payload},{headers:true})
        .then((res)=>{return res.data})
    }
   else{
    return await requestApi.post(`industry/add-edit`,payload,{headers:true})
    .then((res)=>{return res.data})
   }
}

const mutation = useMutation(addIndustry, {
    onSuccess: ( data ) => {
        reset({industryName:''})
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: '',
            text: data?.meta?.message
        }).then(() => {
            navigate(industrymanagement)
        })
    },
    onError: (error) => {
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: '',
            text: error?.message
        })
    }
})
// End add-edit industry////


    // view-industry on id //
    async function viewIndustryOnId(industryId) {
        return await requestApi
            .post(
                `/industry/view`,
                { industryId: industryId },
                { headers: true }
            )
            .then((res) => {
                return res.data
            })
    }

    const { data, isLoading } = useQuery({
        queryKey: ['view-industry'],
        queryFn: () => viewIndustryOnId(industryId),
        enabled: !!industryId,
        onSuccess: (data) => {
            reset({
                industryName:data?.data?.industryName
                // industry: data.data.industry,
                // industryname: JSON.stringify({
                //     industryName: data?.data?.industryName
                // }),
            }) 
        }
    })

    // end industry on id //



 const onSubmit = ({ location, keywords, ...data }) => {
        const payload = {
            ...data,
        }
      
        mutation.mutate(payload)
    }
    return (
        <>
            <div className="sidebar-content">
                <ul className="nav-links">
                    <Link to={industrymanagement}>
                        <li>
                            <a href="">Industry Management</a>
                            <span>&gt;</span>
                        </li>
                    </Link>
                    <li>
                        {industryId ? (
                            <a className="bold">
                                Edit Industry
                            </a>
                        ) : (
                            <a className="bold">
                                Add  Industry
                            </a>
                        )}
                    </li>
                </ul>

                <Form onSubmit={handleSubmit(onSubmit)}>
                    <div className="whitebox">
                        {industryId ? (
                        <div className="title-text">
                            <h3>Edit Industry</h3>
                        </div>
                    ) : (
                        <div className="title-text">
                            <h3>Add  Industry</h3>
                        </div>
                    )}

                        <div className="createnew-box">
                            <div className="row">
                                <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                                    <div className="mb-3 input-wrapper">
                                        <InputControl
                                            label="Industry"
                                            name="industryName"
                                            register={register}
                                            // placeholder="Industry"
                                            error={errors?.industryName?.message}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className="whitebox"> */}
                    <div className="jobdes-btn">
                        <ButtonWithLoader
                            isLoading={mutation?.isLoading}
                            cssClass="common-btn comman-auth-btn reset-btn"
                        >
                            {industryId ? (
                                <button
                                    type="submit"
                                    className="common-btn create"
                                >
                                    Edit
                                </button>
                            ) : (
                                <button
                                    type="submit"
                                    className="common-btn create"
                                >
                                    Add
                                </button>
                            )}
                        </ButtonWithLoader>
                        <button
                            type="button"
                            className="common-btn cancel"
                            onClick={()=>{navigate(industrymanagement)}}
                        >
                            Cancel
                        </button>
                    </div>
                    {/* </div> */}
                </Form>
            </div>
        </>
    )
}

export default AddNewIndustry
